<template>
  <div class="pa-2">
    <div v-if="!itemSlug" class="d-flex flex-row justify-space-between">
      <div class="text-h5">Billing Protocols Admin</div>
      <div>
        <v-btn depressed text :to="{ path: '/boss/billing-protocols/new' }"
          ><v-icon color="green" class="mr-1">mdi-plus</v-icon> Add Page</v-btn
        >
      </div>
    </div>
    <v-fade-transition>
      <generic-admin-list
        v-if="!itemSlug"
        idField="slug"
        title="Billing Protocols"
        :headers="headers"
        api="allProtocols"
        itemsKey="protocols"
        editPath="/boss/billing-protocols"
        detailPath="/billing-protocols/details/"
        :refresh="refresh"
        actionField="title"
        @loaded="refresh = false"
        class="my-2"
      ></generic-admin-list>
      <!--   @displayChange="displayChange($event)" -->
      <!--@doEdit="itemSlug = $event"-->
      <edit-protocol
        v-else
        :slug="itemSlug"
        class="my-2"
        @cancel="itemSlug = null"
      >
        <!-- @edited="itemEdited()" -->
      </edit-protocol>
    </v-fade-transition>
    <!-- <v-snackbar v-model="updatedSnackbar" :timeout="2000" top color="success">
      Item Updated</v-snackbar
    > -->
  </div>
</template>

<script>
// import Name from "../dir/file";
// import ApiServices from "@/services/ApiServices";
import GenericAdminList from "@/components/adminStuff/GenericAdminList";
// import axios from "axios";
import EditProtocol from "./EditProtocol";

export default {
  name: "BillingProtocolsHome",
  components: {
    GenericAdminList,
    EditProtocol,
  },
  props: {},
  data: function () {
    return {
      refresh: true,
      // editId: null,
      // updatedSnackbar: false,
      itemSlug: null,
      headers: [
        { value: "id", text: "Id" },
        { value: "title", text: "Title" },
        { value: "display", text: "Display" },
        { value: "added", text: "Added" },
        { value: "updated", text: "Updated" },
      ],
    };
  },
  methods: {},
  computed: {},
  mounted() {
    this.itemSlug = this.$route?.params?.item ? this.$route.params.item : null;
    // this.getList();
  },
};
</script>

<style scoped></style>
